<template>
<div class="card-body">
  <div class="search-wrap">
    <el-button size="mini" type="primary" @click="editUser()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
    <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
    <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
  </div>

  <div class="table-wrap">
    <el-table v-loading="loading" class="chat-table" :data="tableData">
      <el-table-column prop="id" label="ID" align="left" width="50"></el-table-column>
      <el-table-column prop="name" label="名称" align="center"></el-table-column>
      <el-table-column prop="group_id" label="分组" align="center">
        <template slot-scope="scope">
          <el-select v-model="scope.row.group_id" placeholder="选择分组" @change="setFormItem(scope.row)">
            <el-option v-for="item in groupList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="background" label="背景图" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 50px"
            :src="hostUrl(scope.row.background)"
            fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="font_color" label="字体色" align="center">
        <template slot-scope="scope">
          <el-color-picker v-model="scope.row.font_color" @change="setFormItem(scope.row)"></el-color-picker>
        </template>
      </el-table-column>
      <el-table-column prop="qrcode_style" label="二维码" align="center">
        <template slot-scope="scope">
          <el-select v-model="scope.row.qrcode_style" placeholder="选择二维码" @change="setFormItem(scope.row)">
            <el-option v-for="item in [{name:'公众号',id:1},{name:'企业微信',id:2}]" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" @change="setFormItem(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-edit" @click="editUser(scope.row)">修 改</el-button>
          <el-button type="primary" size="mini" @click="editCardPosterTime(scope.row)">添加任务</el-button>
          <!--          <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteUser(scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
  </div>

  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
  </div>


  <!-- 修改窗口 -->
  <el-dialog title="海报编辑" :visible.sync="dialogVisible" width="1000px">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
      <el-form-item label="主题名称" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分组" prop="group_id">
        <el-select v-model="form.group_id" placeholder="选择分组">
          <el-option v-for="item in groupList" :label="item.name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="背景图" prop="background">
        <UploadFileSysc v-model="form.background" :host-url="host_url" :upload-url="host_url+'/admin/common/uploadFile?name=card_poster'" />
        <p style="color: #F56C6C;">请上传背景图尺寸为：750*1345 px</p>
      </el-form-item>
      <el-form-item label="报文" prop="content">
        <el-input v-model="form.content" type="textarea" :rows="3" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="字体色" prop="font_color">
        <el-color-picker v-model="form.font_color"></el-color-picker>
      </el-form-item>
      <el-form-item label="二维码选项" prop="qrcode_style">
        <el-select v-model="form.qrcode_style" placeholder="选择二维码">
          <el-option v-for="item in [{name:'公众号',id:1},{name:'企业微信',id:2}]" :label="item.name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-switch v-model="form.status" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')" :loading="formLoading">确 定</el-button>
    </div>
  </el-dialog>

  <el-dialog title="海报定时任务编辑" :visible.sync="dialogVisible2" width="1200px">
    <CardPosterTime v-if="dialogVisible2" :poster_id="form.id" />
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible2 = false">取 消</el-button>
    </div>
  </el-dialog>



</div>
</template>

<script>

  import { Loading } from 'element-ui';
  import { User, UserGroup } from './common.js'
  import xhHelp from "./xhHelp";
  import UploadFile from "./components/UploadFile";
  import UploadFileSysc from "./components/UploadFileSysc";
  import CardLayout from "./components/CardLayout";
  import CardPosterTime from "./components/CardPosterTime";

export default {
  name: "CardPoster",
  components: {CardPosterTime, CardLayout, UploadFileSysc, UploadFile},
  data () {
    return {
      is_internal: '',
      group_id: '',
      keyword: '',
      loading: false,
      tableData: [],
      groupList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogVisible2:false,
      formLoading: false,
      form: {
        id:'',
        group_id:'',
        name:'',
        background:'',
        content:'',
        qrcode_style:'',
        font_color:'',
        status:true,
        create_time:'',
        update_time:'',
      },
      form_imgs:null,
      rules: {
        // name: [
        //   { required: true, message: '请填写姓名', trigger: 'blur' },
        // ],
        // phone: [
        //   { required: true, message: '请填写手机号码', trigger: 'blur' },
        // ],
        // is_internal: [
        //   { required: true, message: '请选择是否内部成员', trigger: 'change' },
        // ],
        // group_id: [
        //   { required: true, message: '请选择分组', trigger: 'change' },
        // ],
      },
      articleTableData:[],
      articleKeyword:"",
      hostUrl:xhHelp.hostUrl,
      host_url:xhHelp.host_url,
    }
  },
  created() {

    UserGroup.getList(res => {
      console.log(res)
      if(res.code == 0) {
        this.groupList = res.data
      }
    })

    this.getList()

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        group_id:'',
        name:'',
        background:'',
        content:'',
        qrcode_style:'',
        font_color:'',
        status:true,
        create_time:'',
        update_time:'',
      }, data)
    },
    search() {
      this.page = 1
      this.getList()
    },
    getList() {
      // User.getList({keyword: this.keyword, page: this.page, page_size: this.pageSize}, res => {
      //   if(res.code == 0) {
      //     this.total = res.data.total
      //     this.tableData = res.data.data
      //   }
      // })
      xhHelp.get("CardPoster/getList",{keyword: this.keyword, page: this.page, page_size: this.pageSize},res => {
        if(res.code == 0) {
          if(res.code == 0) {
            this.total = res.data.total
            this.tableData = res.data.data
          }
        }
      })

    },
    pageChange(i) {
      this.page = i
      this.getList()
    },
    editUser(item=null) {
      if(item){
        let data = {}
        for(let k in this.form) {
          data[k] = item[k]
        }
        // this.form_imgs=[{url:this.hostUrl(data.path)}]
        this.form = data
      }else {
        this.form=this.getFormData({})
      }


      //console.log(this.form)

      this.dialogVisible = true
    },
    editCardPosterTime(item=null) {
      if(item){
        let data = {}
        for(let k in this.form) {
          data[k] = item[k]
        }
        // this.form_imgs=[{url:this.hostUrl(data.path)}]
        this.form = data
      }else {
        this.form=this.getFormData({})
      }


      //console.log(this.form)

      this.dialogVisible2 = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          xhHelp.post("CardPoster/update",data,res => {
            this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
            if(res.code == 0) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })

        } else {
          return false;
        }
      });
    },
    setFormItem(item){
      let data = Object.assign({}, item)
      xhHelp.post("CardPoster/update",data,res => {
        this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
        if(res.code == 0) {
          this.getList()
        }
      })
    },
    deleteUser(item) {

      this.$confirm('此操作将删除该会员['+item.phone+'], 是否继续?', '提示', {type: 'warning'}).then(() => {
        User.delete(item.id, res => {
          this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
          if(res.code == 0) {
            this.getList()
          }
        })
      })

    },
    UploadFileFJSuccess(file){
      if(file){
        this.form_imgs=[{url:this.hostUrl(file)}]
      }else {
        this.form_imgs=null
      }

      this.form.path=file;
    },
  }
}
</script>
<style lang="scss" scoped>

  @import './common.scss';
  .theme-content{
    width: 600px;
    height: 300px;
    .theme-content-item{
      cursor: move;
      margin: 5px;
      //height: 40px;
      //line-height: 40px;
      padding: 5px;

      background-color: #7ecbff;
      box-shadow: 0 0 4px -2px #999;
      border-radius: 5px;
      color: white;
    }
    .theme-content-footer{
      text-align: center;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/CardPoster.vue